import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

function extract(res) {
  return res.data.props;
}

@Injectable({
  providedIn: 'root'
})
export class FilesetService {
  private base = '/BPM/API/a/filesets/';
  constructor(private http: HttpClient) { }

  getFileSetSettings(fileSetid: string) {
    return this.http.get(this.base + fileSetid + "/settings")
      .pipe(map(extract));
  }

  getTemplate(id: string) {
    return this.http.get(this.base + id + '/instancetemplate')
      .pipe(map(extract));
  }

  newInstance(organizerId: string, instance)
  {
    return this.http.post(this.base + organizerId + '/newinstance', instance);
  }

  saveInstance(instanceId, state: Object) {
    return this.http.post(this.base + instanceId + '/saveinstance', {State: JSON.stringify(state)});
  }

  getInstance(id) {
    return this.http.get(this.base + id + '/getinstance/')
      .pipe(map(extract));
  }
}
